export default "__VITE_ASSET__DPtfknKb__"